module.exports = __webpack_public_path__ + "static/media/icon-burger.7b3510bc.png";